export default {
  'filter_confirm': 'Confirm',
  'filter_reset': 'Reset',
  'filter_contrast':'Contrast Day',
  'filter_filter_contrast':'Contrast Day',
  'filter_lock_open_message': 'Click to lock the filters, when switching between different pages of the same game, the page will display data according to the locked filters.',
  'filter_lock_close_message': 'Click to unlock the filters, when switching between different pages of the same game, the filters are restored to their default settings.',
  'filter_lock_success': 'Locked successfully',
  'filter_lock_fail': 'Unlocked successfully',
  'filter_lock_expend_message':'After changing the filter criteria, you need to click confirm to refresh the page.',
  'filter_show_message':'Show',
  'filter_close_message':'Close',
  'filter_save_error_message':  "A setting with the same name already exists, Save Failed.",
  'filter_save_statistics_date': "Statistics Date",
  'filter_save_my_filter': "My Filter",
  'filter_save_up_to_10': "Up to 10 settings can be saved",
  'filter_save_setting': "Save Filter Setting",
  'filter_save_can_be_use': "Saved setting can be used in all dashboards except for UA.",
  'filter_save_setting_name': "Setting Name",
  'filter_save_to_be_save':'Items to be saved',
  'filter_save_delete':'delete',
  'filter_save_delete_success':'Delete Successfully.',
  'filter_save_delete_fail':'Delete Failed.',
  'filter_save_save_success':'Save Successfully.',
  'filter_edit_success':'Edit Successfully.',
  'filter_save_save_fail':'Save Failed.',
  'filter_edit_fail':'Edit Failed.',
  'filter_save_delete_setting':'Delete The Setting?',
  'filter_save_sure_to_delete':'Are you sure to delete {name}? The delete operation is irrevocable,Please confirm the operation.',
  'filter_save_enter_a_name':'Please enter name',
  'filter_save_search_placeholder': "Search Filter Setting",
  'filter_save_no_data':'No filter available',
  'filter_edit_setting': "Edit Filter Setting",
  'filter_edit_error_message':  "A Setting With The Same Name Already Exists, Click Save To Replace This Setting.",
  'filter_default_setting':  "Set as default for every dashboard.",
  'filter_default_setting_funnel':  "Set as default.",
  'filter_setting':  "Filter Settings",
  'filter_edit_same_name_success':'{name} Filter setting has updated',
  'filter_save_time_setting':' Time Settings',
  'filter_save_other_setting':'Other Settings',
  'filter_save_latest_date':'Date Duration',
  'filter_save_setting_title':'Two time options are available:',
  'filter_save_setting_info_start_end':'Start & End time: Use the start to end time of the time filter. For example, after saving the scheme, the time filter will fix the query time [{start} to {end}].',
  'filter_save_setting_info_duration':'Date Duration: The shortcut time option selected for the last time is displayed here. For example, after saving the scheme, the time filter will fix the query time [{latestValue}].',
  'filter_save_last_day':'Yesterday',
  'filter_save_last_week':'Last Week',
  'filter_save_last_month':'Last Month',
  'filter_save_last_single_day':'Today',
  'filter_general_filter': 'General Filter',
  'filter_event_filter': 'Event Filter',
  'filter_event_name': 'Event Name',
  'filter_event_parameter': 'Event Parameter',
  'filter_hours_since_register': 'Hours Since Register(h)',
  'filter_event_occur_count': 'Event Occur Count',
  'filter_event_occur_count_range_error': 'The value in the right box must be greater than or equal to the value in the left box',
  'filter_hours_max_exceeded': 'Max value cannot exceed 168',
  'filter_all_event': 'All Event',
  'filter_please_select': 'Please select',
  'filter_please_select_value': 'Please select value',
  'filter_numbers': 'Numbers',
  'filter_cancel': 'Cancel',
  'filter_custom': 'Custom',
  'filter_overall': 'Overall',
  'filter_dimension_filter': 'Dimension',
  'filter_dimension_all_info': 'Display data results on de-duplicated users for all dimensions',
  'filter_event_occur_count_integer_error': 'Please enter an integer',
};